module.exports = __webpack_public_path__ + "static/img/youxiaIcon.5324424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/youxiaIcon.png
// module id = 46gj
// module chunks = 0